import { render } from "./MainToolbar.vue?vue&type=template&id=8f189dc0&scoped=true"
import script from "./MainToolbar.vue?vue&type=script&lang=js"
export * from "./MainToolbar.vue?vue&type=script&lang=js"

import "./MainToolbar.vue?vue&type=style&index=0&id=8f189dc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f189dc0"]])

export default __exports__